import { render, staticRenderFns } from "./VBMap.vue?vue&type=template&id=03a4f165&"
import script from "./VBMap.vue?vue&type=script&lang=js&"
export * from "./VBMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports